import {Component, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {PageTitleComponent} from '../../shared/commons/page-title/page-title.component';
import {ActivatedRoute} from '@angular/router';
import {PortalUserProfileView, UserRole, UserRoleArray} from '../../../models/generated-models';

interface RoleOption {
  role: UserRole;
  label: string;
}

@Component({
  selector: 'app-view-profile',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    PageTitleComponent,
    FormsModule,
    PageTitleComponent,
    PageTitleComponent
  ],
  templateUrl: './view-profile.component.html',
  styleUrl: './view-profile.component.scss',
})
export class ViewProfileComponent implements OnInit {
  protected profile!: PortalUserProfileView;
  protected selectedRoleMap: { [key: string]: boolean } = {};
  protected readonly roles: RoleOption[] = UserRoleArray.map(role => ({role, label: UserRole[role]}));
  private route = inject(ActivatedRoute);

  constructor() {
    this.route.data.subscribe(({profile}) => {
      this.profile = profile;
      this.profile.roles?.forEach(role => this.selectedRoleMap[role] = true);
    });
  }

  ngOnInit(): void {

  }
}
